/**
 * ПЕРЕЕЗД БРАУЗЕРНЫХ ДАННЫХ В АККАУНТ — ПОДПИСКА СИНХРОННАЯ, МОДУЛЬ ЛЕНИВЫЙ (SCRUM-887).
 *
 * «Как только есть аккаунт, всё переезжает в аккаунт» (владелец, 27.10.2026) — это делает
 * `equipment/account-move.ts`, и он тянет за собой склад, `api/stock-api` и всю схему с zod. До
 * 29.10.2026 оболочка импортировала его СТАТИЧЕСКИ, и эти 119 КБ приезжали в каждую страницу,
 * включая лендинг и вход, где аккаунта ещё нет вовсе (замер 28.10: главный файл скриптов вырос на
 * 49% за 20 дней, скачок +119 КБ — коммит 41881c21).
 *
 * Нужен модуль ровно в одном случае: человек завёл аккаунт или вошёл. Поэтому здесь ПОДПИСКА, а не
 * загрузка: `onAccountEntered` принимает замыкание на старте оболочки — событие не теряется, — а
 * `import()` внутри него случается тогда, когда событие уже произошло. Ожидание входа этим не
 * ломается: `auth-service.ts#afterEnter` и так гонит хук против таймаута, а неудавшийся переезд
 * повторяется при следующей загрузке склада (см. `account-move.ts`).
 */
import { onAccountEntered } from "../auth/auth-service";

interface AccountMoveModule {
  moveBrowserDataIntoAccount: (userId: string) => Promise<unknown>;
}

const loadAccountMove = (): Promise<AccountMoveModule> => import("../equipment/account-move");

/** Сам хук, отдельно от подписки, — чтобы тест мог подсунуть свой загрузчик и проверить, что до
 *  события не загружается ничего. */
export function accountMoveHook(
  load: () => Promise<AccountMoveModule> = loadAccountMove
): (user: { id: string }) => Promise<void> {
  return async (user) => {
    const { moveBrowserDataIntoAccount } = await load();
    await moveBrowserDataIntoAccount(user.id);
  };
}

export function installAccountMoveOnEnter(load?: () => Promise<AccountMoveModule>): void {
  onAccountEntered(accountMoveHook(load));
}
